import React, { Fragment, useEffect, useState, useMemo } from "react";
import { OneWayLinkIcon, TwoWayLinkIcon } from "../../../assets/icons";
import {
  IReactSelect,
  ISelectElement,
} from "../../../model/interface/keyValuePair";
import { addLinking } from "../../../api/standardLinking.service";
import Select, { SingleValue } from "react-select";
import { IStandard } from "../../../model/interface/standard";
import StandardDetail from "./standardDetail";
import {
  getStandard,
  getStandardByIds,
  getStandardsByDomain,
  getStandardsByDomainAndSourceStandard,
} from "../../../api/standard.service";
import ExistingLinking from "./existingLinking";
import { connect } from "react-redux";
import Constant from "../../../utils/constant";
import Loader from "../../shared/loader/loader";
import { useLocation } from "react-router";
import MultiSelect from "../../shared/common/multiSelect";
import { toast } from "react-toastify";
import MultiInput from "../../shared/common/multiInput";
import debounce from "lodash.debounce";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import reactSelect from "react-select";

function StandardLink(props: any) {
  const defaultValue: ISelectElement = { label: "", value: "" };
  const defaultElement: ISelectElement[] = [defaultValue];

  const [sourceContentAreas, setSourceContentAreas] = useState<
    ISelectElement[]
  >([]);
  const [sourceSubjects, setSourceSubjects] = useState<ISelectElement[]>([]);
  const [sourceDomains, setSourceDomains] = useState<ISelectElement[]>([]);
  const [sourceStandards, setSourceStandards] = useState<ISelectElement[]>([]);
  const [sourceSelectedContent, setSourceSelectedContent] =
    useState<ISelectElement>(defaultValue);
  const [sourceSelectedSubject, setSourceSelectedSubject] =
    useState<ISelectElement>(defaultValue);
  const [sourceSelectedDomain, setSourceSelectedDomain] =
    useState<ISelectElement>(defaultValue);
  const [sourceSelectedStandard, setSourceSelectedStandard] =
    useState<ISelectElement>(defaultValue);
  const [sourceStandardDetails, setSourceStandardDetails] = useState<
    IStandard[]
  >([]);
  const [sourceStandardId, setSourceStandardId] = useState<number>();

  const [destinationContentAreas, setDestinationContentAreas] = useState<
    ISelectElement[]
  >([]);
  const [destinationSubjects, setDestinationSubjects] = useState<
    ISelectElement[]
  >([]);
  const [destinationDomains, setDestinationDomains] = useState<
    ISelectElement[]
  >([]);
  const [destinationStandards, setDestinationStandards] = useState<
    ISelectElement[]
  >([]);
  const [destinationStandardId, setDestinationStandardId] = useState<string>();
  const [destinationSelectedContent, setDestinationSelectedContent] =
    useState<ISelectElement>(defaultValue);
  const [destinationSelectedSubject, setDestinationSelectedSubject] =
    useState<ISelectElement>(defaultValue);
  const [destinationSelectedDomain, setDestinationSelectedDomain] =
    useState<ISelectElement>(defaultValue);
  const [destinationSelectedStandard, setDestinationSelectedStandard] =
    useState<Array<ISelectElement>>([]);
  const [destinationStandardDetails, setDestinationStandardDetails] = useState<
    IStandard[]
  >([]);
  const [selectedDestinationStandards, setSelectedDestinationStandards] =
    useState<number[]>([]);

  const [selectedSourceStandard, setSelectedSourceStandard] =
    useState<number>();
  const [linkingType, setLinkingType] = useState<string>(
    Constant.StandardLinkingType.ONEWAY
  );
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [existingLinkingKey, setExistingLinkingKey] = useState<number>();
  const [disableLink, setDisableLink] = useState<boolean>(true);
  const location = useLocation();
  const parameters = location.state as any;
  const [selectedSearchString, setSelectedSearchString] = useState<any>([]);
  const [options, setOptions] = useState<any>([]);

  async function bindContentAreas() {
    const service = await import("../../../api/contentArea.service");
    service.getContentArea().then((response) => {
      let contentAreas: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        contentAreas = response.data.data.map((contentArea) => {
          return {
            value: contentArea.contentAreaId || 0,
            label: `${contentArea.name}`,
          };
        });
      }
      setSourceContentAreas([...contentAreas]);
      setDestinationContentAreas([...contentAreas]);
    });
  }

  async function bindSourceSubjects(contentId: number | string) {
    setShowLoading(true);
    const service = await import("../../../api/subject.service");
    service.getSubjectAllByContent(contentId).then((response) => {
      setShowLoading(false);
      let subjects: ISelectElement[] = [];
      if (response.data.length > 0) {
        subjects = response.data.map((subject) => {
          return {
            value: subject.subjectId || 0,
            label: `${subject.subjectName}`,
          };
        });
      }
      setSourceSubjects([...subjects]);
    });
  }

  async function bindSourceDomains(subjectId: number | string) {
    setShowLoading(true);
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(subjectId).then((response) => {
      setShowLoading(false);
      let domains: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        domains = response.data.data.map((domain) => {
          return {
            value: domain.domainId || 0,
            label: `${domain.name}`,
          };
        });
      }
      setSourceDomains([...domains]);
    });
  }

  function bindSourceStandards(domainId: number | string) {
    setShowLoading(true);
    getStandardsByDomain(domainId).then((response) => {
      setShowLoading(false);
      let standards: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        standards = response.data.data.map((standard) => {
          return {
            value: standard.standardId || 0,
            label: `[${standard.code}] ${standard.name}`,
          };
        });
      }
      setSourceStandards(standards);
    });
  }

  function handleSourceContentChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (!selectedItem) return;

    setSourceSelectedContent(selectedItem);
    handleDestinationContentChange(selectedItem);
    bindSourceSubjects(selectedItem.value);
    setSourceDomains(defaultElement);
    setSourceSelectedSubject(defaultValue);
    setSourceSelectedDomain(defaultValue);
  }

  function handleSourceSubjectChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (!selectedItem) return;
    setSourceSelectedSubject(selectedItem);

    bindSourceDomains(selectedItem.value);
    setSourceSelectedDomain(defaultValue);
  }

  function handleSourceDomainChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (!selectedItem) return;
    setSourceSelectedDomain(selectedItem);
    bindSourceStandards(selectedItem.value);
  }

  function handleSourceStandardChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (selectedItem) {
      setSourceSelectedStandard(selectedItem);
      setSourceStandardId(undefined);
    }
  }

  async function bindDestinationSubjects(contentId: number | string) {
    setShowLoading(true);
    const service = await import("../../../api/subject.service");
    service.getSubjectAllByContent(contentId).then((response) => {
      setShowLoading(false);
      let subjects: ISelectElement[] = [];
      if (response.data.length > 0) {
        subjects = response.data.map((subject) => {
          return {
            value: subject.subjectId || 0,
            label: `${subject.subjectName}`,
          };
        });
      }
      setDestinationSubjects([...subjects]);
    });
  }

  async function bindDestinationDomains(subjectId: number | string) {
    setShowLoading(true);
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(subjectId).then((response) => {
      setShowLoading(false);
      let domains: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        domains = response.data.data.map((domain) => {
          return {
            value: domain.domainId || 0,
            label: `${domain.name}`,
          };
        });
      }
      setDestinationDomains([...domains]);
    });
  }

  function bindDestinationStandards(domainId: number | string) {
    setShowLoading(true);
    getStandardsByDomain(domainId).then((response) => {
      setShowLoading(false);
      let standards: ISelectElement[] = [];
      if (response.data.data.length > 0) {
        standards = response.data.data.map((standard) => {
          return {
            value: standard.standardId || 0,
            label: `[${standard.code}] ${standard.name}`,
          };
        });
      }
      setDestinationStandards(standards);
    });
  }

  function handleDestinationContentChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (!selectedItem) return;
    setDestinationSelectedContent(selectedItem);
    bindDestinationSubjects(selectedItem.value);
    setDestinationDomains(defaultElement);
    setDestinationSelectedSubject(defaultValue);
    setDestinationSelectedDomain(defaultValue);
    setDestinationSelectedStandard([]);
  }

  function handleDestinationSubjectChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (!selectedItem) return;
    setDestinationSelectedSubject(selectedItem);
    bindDestinationDomains(selectedItem.value);
    setDestinationSelectedDomain(defaultValue);
  }

  function handleDestinationDomainChange(
    selectedItem: SingleValue<ISelectElement> | null
  ) {
    if (!selectedItem) return;
    setDestinationSelectedDomain(selectedItem);
    bindDestinationStandards(selectedItem.value);
    setDestinationStandardId(undefined);
  }

  function handleDestinationStandardChange(newValue, actionMeta) {
    setDestinationStandardId(undefined);
  }

  function handleSourceStandardDetailChange(standardId: number) {
    setSelectedSourceStandard(standardId);
    setExistingLinkingKey(standardId);
    if (
      selectedDestinationStandards &&
      selectedDestinationStandards.length > 0
    ) {
      setDisableLink(false);
    } else {
      setDisableLink(true);
    }
  }

  function handleDestinationStandardDetailChange(
    e: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) {
    const checked = e.target.checked;
    const currentItems = selectedDestinationStandards;
    if (checked) {
      currentItems.push(id);
    } else {
      const itemIndex = currentItems.indexOf(id);
      currentItems.splice(itemIndex, 1);
    }
    setSelectedDestinationStandards(currentItems);
    if (
      selectedSourceStandard &&
      selectedSourceStandard > 0 &&
      currentItems.length > 0
    ) {
      setDisableLink(false);
    } else {
      setDisableLink(true);
    }
  }

  function handleSourceSearchClick(autoFillData?) {
    let selectedStandardId =
      autoFillData && autoFillData.standardId
        ? autoFillData.standardId
        : sourceStandardId;

    if (!selectedStandardId) {
      selectedStandardId = parseInt(sourceSelectedStandard.value);
    }
    if (selectedStandardId) {
      if (
        sourceStandardId &&
        destinationStandardId === sourceStandardId.toString()
      ) {
        toast.warning("Source and destination standard ids should not be same");
      } else {
        setShowLoading(true);
        getStandard(selectedStandardId).then((response) => {
          setShowLoading(false);
          if (response.data) {
            setSourceStandardDetails([response.data]);
          } else {
            setSourceStandardDetails([]);
          }
          if (autoFillData && autoFillData.standardId) {
            const getIsActiveSourceElem: any =
              document.getElementById("isActiveSource");
            if (getIsActiveSourceElem) getIsActiveSourceElem.checked = true;
          }
        });
      }
    } else {
      toast.warning("Please select standard");
    }
  }

  function handleDestinationSearchClick() {
    setShowLoading(true);
    if (destinationStandardId) {
      if (
        sourceStandardId &&
        destinationStandardId === sourceStandardId.toString()
      ) {
        setShowLoading(false);
        toast.warning(
          "Source and destination standard ids should not be same d"
        );
      } else {
        getStandardByIds(destinationStandardId).then((response) => {
          setShowLoading(false);
          if (response.data.data) {
            setDestinationStandardDetails(response.data.data);
          } else {
            setDestinationStandardDetails([]);
          }
        });
      }
    } else {
      let search = "";
      if (selectedSearchString.length)
        selectedSearchString.map((ds) => {
          search += ".*|" + ds.label;
        });
      getStandardsByDomainAndSourceStandard(
        parseInt(destinationSelectedDomain.value) || 0,
        parseInt(sourceSelectedStandard.value) || 0,

        search,
        parseInt(destinationSelectedContent.value) || undefined
      ).then((response) => {
        setShowLoading(false);
        const result = response.data.data;
        if (result && result.length > 0) {
          if (
            destinationSelectedStandard &&
            destinationSelectedStandard.length > 0
          ) {
            const selectedIds = destinationSelectedStandard.map((r) => r.value);
            const standardDetails = result.filter((r) =>
              selectedIds.includes(r.standardId)
            );

            setDestinationStandardDetails(standardDetails);
          } else {
            setDestinationStandardDetails(result);
          }
        }
      });
    }
  }

  function bindInitialData() {
    bindContentAreas();
  }

  function handleLink() {
    if (
      selectedSourceStandard &&
      selectedSourceStandard > 0 &&
      selectedDestinationStandards.length > 0
    ) {
      setShowLoading(true);

      const promises: any = [];
      selectedDestinationStandards.forEach((standardId: number) => {
        if (selectedSourceStandard !== standardId) {
          promises.push(
            addLinking(
              props.profile?.userId,
              selectedSourceStandard,
              standardId
            )
          );
        }
      });

      if (linkingType === Constant.StandardLinkingType.TWOWAY) {
        selectedDestinationStandards.forEach((standardId: number) => {
          if (selectedSourceStandard !== standardId) {
            promises.push(
              addLinking(
                props.profile?.userId,
                standardId,
                selectedSourceStandard
              )
            );
          }
        });
      }

      if (promises.length > 0) {
        setShowLoading(false);
        const ele: any = document.getElementsByClassName("isActiveDestination");
        for (let i = 0; i < ele.length; i++) {
          if (ele[i].checked) ele[i].checked = false;
        }

        Promise.all(promises).then(() => {
          toast.success("Selected standard linked successfully");
          setExistingLinkingKey(Math.random());
          handleDestinationSearchClick();
        });
      } else {
        toast.warning("Source and destination standard ids should not be same");
        handleDestinationSearchClick();
      }
    }
  }

  useEffect(() => {
    const multiSelectInput: any = document.querySelector("#search-text input");
    const multiSelectInputServer: any =
      document.querySelector(".css-912qm0 input") ||
      document.querySelector(".css-1446j1a input");

    if (multiSelectInput) {
      multiSelectInput.addEventListener("input", debouncedChangeHandler);
    } else {
      multiSelectInputServer?.addEventListener("input", debouncedChangeHandler);
    }

    const arrow: any = document.querySelectorAll(
      ".css-tlfecz-indicatorContainer"
    );
    if (arrow[8]) {
      arrow[8].style.display = "none";
    }
  }, []);

  const onSearchStringChange = (e) => {
    const menu: any = document.querySelector(".css-26l3qy-menu");

    if (menu) {
      menu.style.display = "none";
    }
    options.push({ label: e.target.value, value: e.target.value });
    setOptions([]);
    setOptions(options);
  };

  const onAllRemove = () => {
    setOptions([]);
    setSelectedSearchString([]);
  };

  const debouncedChangeHandler = useMemo(
    () => debounce(onSearchStringChange, 100),
    []
  );

  useEffect(() => {
    bindInitialData();
    if (
      parameters &&
      parameters.autoFillData &&
      Object.keys(parameters.autoFillData).length
    ) {
      if (parameters.autoFillData.contentId) {
        setSourceSelectedContent({
          label: parameters.autoFillData.contentName,
          value: parameters.autoFillData.contentId,
        });
        setDestinationSelectedContent({
          label: parameters.autoFillData.contentName,
          value: parameters.autoFillData.contentId,
        });
        bindSourceSubjects(parameters.autoFillData.contentId);
        bindDestinationSubjects(parameters.autoFillData.contentId);
      }

      if (parameters.autoFillData.subjectId) {
        setSourceSelectedSubject({
          label: parameters.autoFillData.subjectName,
          value: parameters.autoFillData.subjectId,
        });
        bindSourceDomains(parameters.autoFillData.subjectId);
        bindDestinationDomains(parameters.autoFillData.subjectId);
      }

      if (parameters.autoFillData.domainId) {
        setSourceSelectedDomain({
          label: parameters.autoFillData.domainName,
          value: parameters.autoFillData.domainId,
        });
        bindSourceStandards(parameters.autoFillData.domainId);
        bindDestinationStandards(parameters.autoFillData.domainId);
      }

      if (parameters.autoFillData.standardId) {
        setSourceSelectedStandard({
          label: `[${parameters.autoFillData.code}] ${parameters.autoFillData.name}`,
          value: parameters.autoFillData.standardId,
        });
        setSourceStandardId(parameters.autoFillData.standardId);
      }

      handleSourceSearchClick(parameters.autoFillData);
      handleSourceStandardDetailChange(parameters.autoFillData.standardId);
    }
  }, []);

  return (
    <AllowedTo
      perform={Permissions.standard_linking_view}
      no={() => <AccessDenied />}
    >
      {showLoading && <Loader />}

      <div className="px-4 mt-6 sm:px-6 lg:px-8 w-full">
        <h3 className="mb-6 text-lg font-light text-gray-900">
          Standard Linking
        </h3>
        <div className="grid grid-cols-12 gap-y-5 gap-x-6 border-b border-gray-300 pb-6">
          <div className="col-span-5 border rounded p-3">
            <h2 className="text-primary-color dark:text-white mb-3 font-medium tracking-wide border-b pb-2">
              Source Element
            </h2>
            <div className="grid grid-cols-12 gap-y-5 gap-x-6">
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  Content Area
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    options={sourceContentAreas}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={sourceSelectedContent}
                    onChange={handleSourceContentChange}
                    isSearchable={true}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  Subject
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    options={sourceSubjects}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={sourceSelectedSubject}
                    onChange={handleSourceSubjectChange}
                    isSearchable={true}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  Domain
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    options={sourceDomains}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={sourceSelectedDomain}
                    onChange={handleSourceDomainChange}
                    isSearchable={true}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  Standard
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    placeholder=""
                    options={sourceStandards}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={sourceSelectedStandard}
                    onChange={handleSourceStandardChange}
                    isSearchable={true}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  Standard Id
                </div>
                <div className="mt-1 relative col-span-5">
                  <input
                    id="standardId"
                    name="standardId"
                    autoComplete="off"
                    type="text"
                    value={sourceStandardId || ""}
                    onChange={(e) => {
                      setSourceStandardId(parseInt(e.target.value));
                    }}
                    className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                  />
                </div>
              </div>
              <div className="col-span-12 flex items-end justify-end">
                <button
                  type="button"
                  className="mt-2 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  onClick={() => {
                    handleSourceSearchClick();
                  }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
          <div className="col-span-2"></div>
          <div className="col-span-5 border rounded p-3">
            <h2 className="text-primary-color dark:text-white mb-3 font-medium tracking-wide border-b pb-2">
              Destination Element
            </h2>
            <div className="grid grid-cols-12 gap-y-5 gap-x-6">
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  {" "}
                  Content Area
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    options={destinationContentAreas}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={destinationSelectedContent}
                    isSearchable={true}
                    onChange={handleDestinationContentChange}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  {" "}
                  Subject
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    options={destinationSubjects}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={destinationSelectedSubject}
                    isSearchable={true}
                    onChange={handleDestinationSubjectChange}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  {" "}
                  Domain
                </div>
                <div className="mt-1 relative col-span-5">
                  <Select
                    options={destinationDomains}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                    value={destinationSelectedDomain}
                    onChange={handleDestinationDomainChange}
                    isSearchable={true}
                  ></Select>
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  Standard
                </div>
                <div className="mt-1 relative col-span-5">
                  <MultiSelect
                    options={destinationStandards}
                    selectedItems={destinationSelectedStandard}
                    setSelectedItems={setDestinationSelectedStandard}
                    onChange={handleDestinationStandardChange}
                  />
                </div>
              </div>
              <div className="col-span-6">
                <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
                  {" "}
                  Standard Id
                </div>
                <div className="mt-1 relative col-span-5">
                  <input
                    id="standardId"
                    name="standardId"
                    autoComplete="off"
                    type="text"
                    value={destinationStandardId || ""}
                    onChange={(e) => {
                      setDestinationStandardId(e.target.value);
                    }}
                    className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                  />
                </div>
              </div>
              <div className="col-span-6 ">
                <label className="text-sm text-gray-700">Search Text</label>
                <div className="contentArea mt-1" id="search-text">
                  <MultiInput
                    options={options}
                    selectedItems={selectedSearchString}
                    setSelectedItems={setSelectedSearchString}
                    onAllRemove={onAllRemove}
                  />
                </div>
              </div>
              <div className="col-span-12 flex items-end justify-end">
                <button
                  onClick={() => handleDestinationSearchClick()}
                  className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                >
                  <span>Search</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-y-5 gap-x-6">
          <div className="col-span-5">
            {sourceStandardDetails &&
              sourceStandardDetails.map((standard, index) => {
                return (
                  <Fragment key={index}>
                    <StandardDetail
                      {...standard}
                      allowMultiSelect={false}
                      onSourceChange={handleSourceStandardDetailChange}
                    />
                  </Fragment>
                );
              })}
          </div>

          <div className="col-span-2 ">
            <fieldset className="flex h-full justify-center items-start mt-5">
              <legend className="sr-only">Privacy setting</legend>
              <div className="bg-white rounded-md -space-y-px">
                <div className="bg-white rounded-md -space-y-px">
                  <label className="relative rounded-tl-md rounded-tr-md border p-4 flex cursor-pointer focus:outline-none bg-indigo-50 border-indigo-200 z-10">
                    <span className="absolute right-3 top-2 text-primary-color font-medium">
                      <OneWayLinkIcon />
                    </span>

                    <input
                      type="radio"
                      x-model="value"
                      name="privacy-setting"
                      value="Private to you"
                      checked={true}
                      className="h-4 w-4 mt-0.5 cursor-pointer text-primary-color border-gray-300 focus:ring-primary-color"
                      onChange={() =>
                        setLinkingType(Constant.StandardLinkingType.ONEWAY)
                      }
                    />
                    <div className="ml-3 flex flex-col">
                      <span
                        id="privacy-setting-0-label"
                        className="block text-sm font-medium text-gray-900"
                      >
                        One Way Linking
                      </span>
                      <span
                        id="privacy-setting-0-description"
                        className="block text-xs text-gray-500 mt-2"
                      >
                        This project would be available to anyone who has the
                        link
                      </span>
                    </div>
                  </label>

                  <label className=" relative border p-4 flex cursor-pointer focus:outline-none border-gray-200 hover:bg-indigo-50 dark:hover:bg-gray-900">
                    <span className="absolute right-3 top-2 text-primary-color font-medium">
                      <TwoWayLinkIcon />
                    </span>
                    <input
                      type="radio"
                      x-model="value"
                      name="privacy-setting"
                      value="Private to you"
                      className="h-4 w-4 mt-0.5 cursor-pointer text-primary-color border-gray-300 focus:ring-primary-color"
                      onChange={() =>
                        setLinkingType(Constant.StandardLinkingType.TWOWAY)
                      }
                    />
                    <div className="ml-3 flex flex-col">
                      <span
                        id="privacy-setting-2-label"
                        className="block text-sm font-medium text-gray-900"
                      >
                        Two Way Linking
                      </span>
                      <span
                        id="privacy-setting-2-description"
                        className="text-xs text-gray-500 mt-2"
                      >
                        You are the only one able to access this project
                      </span>
                    </div>
                  </label>
                  <div className="py-2 rounded-bl-md rounded-br-md relative border flex justify-center  cursor-pointer focus:outline-none border-gray-200 hover:bg-indigo-50 dark:hover:bg-gray-900">
                    <AllowedTo perform={Permissions.standard_linking_create}>
                      <button
                        type="button"
                        className={`${
                          disableLink
                            ? "opacity-50 dark:opacity-100 dark:text-gray-300 cursor-not-allowed "
                            : ""
                        }  mt-2 inline-flex items-center text-sm text-white gap-2 bg-primary-color dark:bg-gray-700 hover:bg-secondary-color py-1.5 px-4 rounded-lg`}
                        onClick={() => handleLink()}
                      >
                        Link
                      </button>
                    </AllowedTo>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div className="col-span-5">
            {destinationStandardDetails.map((standard, index) => {
              return (
                <Fragment key={index}>
                  <StandardDetail
                    {...standard}
                    allowMultiSelect={true}
                    onDestinationChange={handleDestinationStandardDetailChange}
                  />
                </Fragment>
              );
            })}
          </div>
        </div>
        {selectedSourceStandard && (
          <ExistingLinking
            key={existingLinkingKey}
            standardId={selectedSourceStandard}
            userId={props.profile?.userId}
          />
        )}
      </div>
    </AllowedTo>
  );
}

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(StandardLink);
